import { useTheme } from '@mui/material';

export const FilterIcon = () => {
    const theme = useTheme();
    const {
        stroke: { secondary: secondaryStroke },
        background: { secondary: secondaryBackground },
    } = theme.colors.other.icon;

    return (
        <svg
            width="64"
            height="64"
            viewBox="0 0 64 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12.4157 13.768L12.4146 13.7667C12.2032 13.526 12.0656 13.2296 12.0183 12.9128C11.971 12.596 12.016 12.2723 12.1478 11.9804C12.2797 11.6886 12.4929 11.4409 12.7619 11.267C13.0307 11.0932 13.3439 11.0005 13.664 11H49.9292C50.2493 11.0005 50.5625 11.0932 50.8314 11.267C51.1004 11.4409 51.3136 11.6886 51.4454 11.9804C51.5773 12.2723 51.6223 12.596 51.575 12.9128C51.5277 13.2296 51.3901 13.526 51.1787 13.7667L51.1775 13.768L36.3775 30.6747C36.2179 30.857 36.13 31.091 36.13 31.3333V46.8126C36.13 47.5701 35.702 48.2626 35.0244 48.6014L30.3577 50.9348C29.0279 51.5997 27.4633 50.6327 27.4633 49.1459V31.3333C27.4633 31.091 27.3753 30.857 27.2157 30.6747L12.4157 13.768Z"
                stroke={secondaryStroke}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.8667 17.4267L32.6667 34.3333V52.1459C32.6667 54.376 35.0136 55.8265 37.0083 54.8292L41.675 52.4958C42.6913 51.9877 43.3333 50.9489 43.3333 49.8126V34.3333L58.1333 17.4267C58.4716 17.0417 58.6917 16.5674 58.7674 16.0605C58.8431 15.5537 58.7711 15.0357 58.5601 14.5687C58.3491 14.1017 58.008 13.7054 57.5776 13.4272C57.1472 13.1489 56.6458 13.0006 56.1333 13H19.8667C19.3542 13.0006 18.8528 13.1489 18.4224 13.4272C17.992 13.7054 17.6509 14.1017 17.4399 14.5687C17.2289 15.0357 17.1569 15.5537 17.2326 16.0605C17.3083 16.5674 17.5284 17.0417 17.8667 17.4267Z"
                fill={secondaryBackground}
            />
        </svg>
    );
};
